import { render, staticRenderFns } from "./areaRegistration.vue?vue&type=template&id=948c9f3c&scoped=true&"
import script from "./areaRegistration.vue?vue&type=script&lang=js&"
export * from "./areaRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948c9f3c",
  null
  
)

export default component.exports